import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { BaseEdge, getStraightPath, useInternalNode } from "@xyflow/react";
import { GATEWAY_SIZE } from "../constants";
/**
 * Visual anchor point of a node in absolute flow coordinates. Usually the
 * bounding-box centre — but a decision/gateway is a 60×90 box with the diamond
 * at the top and its rule outputs stacked below, so its box centre lands on the
 * rule list. Aim at the diamond's centre (`GATEWAY_SIZE / 2` from the top)
 * instead so the connector points at the diamond.
 */ function nodeCenter(node) {
    const { x, y } = node.internals.positionAbsolute;
    const width = node.measured?.width ?? 0;
    const height = node.measured?.height ?? 0;
    const offsetY = node.type === "flowGateway" ? GATEWAY_SIZE / 2 : height / 2;
    return {
        x: x + width / 2,
        y: y + offsetY
    };
}
/**
 * Floating connector from a sticky note to a node it targets (ADR 0008).
 * Notes carry no handles, so the line is drawn centre-to-centre from the live
 * node positions (re-routes automatically when either end moves). Thin dashed
 * grey, non-interactive — it's an annotation pointer, not a flow edge.
 */ function NoteConnectorEdge({ id, source, target }) {
    const sourceNode = useInternalNode(source);
    const targetNode = useInternalNode(target);
    if (!sourceNode || !targetNode) return null;
    const s = nodeCenter(sourceNode);
    const e = nodeCenter(targetNode);
    const [path] = getStraightPath({
        sourceX: s.x,
        sourceY: s.y,
        targetX: e.x,
        targetY: e.y
    });
    return /*#__PURE__*/ _jsx(BaseEdge, {
        id: id,
        path: path,
        style: {
            stroke: "var(--color-gray-400)",
            strokeWidth: 1,
            strokeDasharray: "4 4"
        }
    });
}
export default /*#__PURE__*/ memo(NoteConnectorEdge);

//# sourceMappingURL=NoteConnectorEdge.js.map